(function() {
    // 设置模板
    template.config('escape', false);

    // 通用红涨绿跌
    template.helper('upDownStyle', function(data, type, cpVal, isAbs) {
        // type: 'percent'，开关：off
        // cpVal: 比较值
        // isAbs: 取绝对值
        // console.log(data, type, cpVal, isAbs);
        if (type === 'off') {
            return data;
        }
        if (!data) {
            return '';
        }
        var comparisonValue = cpVal || data;
        type = type || '';
        if (typeof comparisonValue === 'string') {
            if ((comparisonValue.indexOf('-') === 0 && comparisonValue !== '--') || comparisonValue === '利空' || comparisonValue === '强烈利空') {
                data = '<span class="stock-go-down ' + type + '">' + data + '</span>';
            } else if (comparisonValue === '0.00' || comparisonValue === '0.00%' || comparisonValue === '--' || comparisonValue === '中性') {
                data = '<span class="stock-go-eq ' + type + '">' + data + '</span>';
            } else {
                data = '<span class="stock-go-up ' + type + '">' + data + '</span>';
            }
        } else if (typeof comparisonValue === 'number') {
            if (comparisonValue > 0) {
                data = '<span class="stock-go-up ' + type + '">' + data + '</span>';
            } else if (comparisonValue < 0) {
                data = '<span class="stock-go-down ' + type + '">' + data + '</span>';
            } else {
                data = '<span class="stock-go-eq ' + type + '">' + data + '</span>';
            }
        }
        if (isAbs && comparisonValue.indexOf('-') !== -1) {
            data = data.replace(comparisonValue, comparisonValue.slice(1));
        }
        return data;
    });

    // 股价预测-波动区间
    template.helper('predictOneDay', function(num) {
        var low = Number(num.flucFlor);
        var height = Number(num.flucCeil);
        var pointer = Number(num.priceProg.toFixed(2));
        var total_distance = Number(height - low);
        var left_distance = Number(pointer - low);
        var distance = left_distance / total_distance * 100;
        var posStyle = distance < 20 ? 'left' : 'width';
        var posStyleName = distance < 20 ? ' scale' : '';
        var html = '<div class="pointer" style="width:' + distance + '%"></div><div class="price'+ posStyleName +'" id="oneday_price" style="'+ posStyle +':' + distance + '%"><span class="wd">预期价</span><span>' + pointer + '</span></div>';
        return html;
    });
    // 股价预测-上涨概率
    template.helper('predictStyle', function(num) {
        num = (num * 100).toFixed(2);

        var html = '<div class="progress {stock-state-style}" style="width: ' + num + '%;"><span class="scale {stock-scale-style}">' + num + '%</span></div>';

        if (num > 0 && num < 16) {
            html = html.replace('{stock-state-style}', '');
            html = html.replace('{stock-scale-style}', 'scale-right');
        } else if (num > 30 && num < 60) {
            html = html.replace('{stock-scale-style}', '');
            html = html.replace('{stock-state-style}', 'medium');
        } else if (num >= 60) {
            html = html.replace('{stock-scale-style}', '');
            html = html.replace('{stock-state-style}', 'high');
        }

        return html;
    });

    // 个股行情、个股诊断股、个股资金
    template.helper('StockDetailStyle', function(currentPrice, changeAmount, changeAmountRate) {
        var iCurrentPrice = Number(currentPrice);
        var iChangeAmount = Number(changeAmount);
        var iChangeAmountRate = Number(changeAmountRate);
        var stockStateStyle = 'stock-go-eq';

        if (iChangeAmount > 0) {
            stockStateStyle = 'stock-go-up';
        } else if (iChangeAmount < 0) {
            stockStateStyle = 'stock-go-down';
        }
        if (iCurrentPrice < 0.001) {
            currentPrice = changeAmount = changeAmountRate = '--';
        }
        if (currentPrice === undefined) {
            currentPrice = '--';
        }
        if (changeAmount === undefined) {
            changeAmount = '--';
        }
        if (changeAmountRate === undefined) {
            changeAmountRate = '--';
        }

        return '<span class="' + stockStateStyle + '"><em class="now">' + currentPrice + '</em><small class="dif">' + changeAmount + '</small><small class="percent">' + changeAmountRate + '</small></span>';
    });

    // 场景设置
    /**
     * @name setScene
     * @param {object}    sceneSettings          场景设定
     * @param {string}    type                   当前项目设定类型：detail, blockDetail, more
     */
    template.helper('setScene', function(sceneSettings, type) {
        if (!sceneSettings) {
            return;
        }
        var sceneHook = '';

        if (sceneSettings[type]) {
            sceneHook = 'tapHighLight J_invokeAppEvent';
            if (type === 'more') {
                sceneHook += ' sr-show';
            }
        }
        return sceneHook;
    });
})();